// used in PokeList for sorting function
const SortTypes = {
  ABC: 1,
  HEIGHT: 2,
  WEIGHT:3,
  DEX_NO: 4,
}

export default SortTypes;